import React, { useMemo } from 'react';
import { Box, Button, Flex, Text, Tooltip } from '@chakra-ui/react';
import { useBlockchainProvider } from '../../../providers/Blockchain/blockchainProvider';
import useNetworks, { Network } from '../../../providers/Networks/useNetworks';
import { blockchainConfig } from '../../../blockchain-config';
import { Color } from '../../../theme/color';
import { getTransparent } from '../../../utils/themer';

interface IMode {
	color?: string;
	name: string;
}

const mode: { [p: number]: IMode } = {
	[Network.POLYGON_MAINNET]: {
		color: '#8247E5',
		name: 'Polygon',
	},
	[Network.MUMBAI_TESTNET]: {
		color: '#8247E5',
		name: 'Polygon Testnet',
	},
	[Network._]: {
		name: 'Wrong network',
	},
};

export const NetworkPane = () => {
	const { chainId, provider } = useBlockchainProvider();
	const { switchNetwork } = useNetworks();

	const modeIndex = useMemo(() => {
		if (![blockchainConfig.NETWORK_DEFAULT.ID].includes(chainId) || !provider) {
			return Network._;
		}

		return chainId;
	}, [chainId, provider]);

	return (
		<Tooltip
			label="Switch network"
			placement="bottom-end"
			isDisabled={modeIndex === blockchainConfig.NETWORK_DEFAULT.ID}
		>
			<Button
				variant="unstyled"
				height="auto"
				display="flex"
				flexDirection="column"
				alignItems="flex-start"
				justifyContent="flex-start"
				fontWeight="400"
				fontSize="14px"
				lineHeight="14px"
				disabled={modeIndex === blockchainConfig.NETWORK_DEFAULT.ID}
				_disabled={{ cursor: 'auto' }}
				onClick={() => (modeIndex !== blockchainConfig.NETWORK_DEFAULT.ID ? switchNetwork() : null)}
			>
				<Text
					fontSize="12px"
					lineHeight="18px"
					marginLeft="22px"
					color={getTransparent(Color.TEXT, 50)}
				>
					Network
				</Text>
				<Flex
					gap="8px"
					color={modeIndex === Network._ ? 'action' : 'text'}
				>
					<Box
						bg={mode[modeIndex].color}
						borderRadius="full"
						height="1em"
						width="1em"
					/>
					<Text fontWeight="500">{mode[modeIndex].name}</Text>
				</Flex>
			</Button>
		</Tooltip>
	);
};
